import { render, staticRenderFns } from "./App.vue?vue&type=template&id=38b2956c&"
import script from "./scripts/index.js?vue&type=script&lang=js&"
export * from "./scripts/index.js?vue&type=script&lang=js&"
import style0 from "@/css/scss/style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports